import axios from 'axios'
import { CONTACT_MANAGER_ENDPOINT } from '../../../consts/env'
import { CategoryQueue } from '../types'

export const getPercentageVisibilityByTag = async (solutionTag: CategoryQueue) => {
  if (solutionTag === null) return { percentageVisibility: 0, withinOpenHours: false }

  try {
    const response = await axios.get(`${CONTACT_MANAGER_ENDPOINT}/solution/${solutionTag.toLocaleLowerCase()}`)
    if (response.status !== 200) return { percentageVisibility: 0, withinOpenHours: false }
    return {
      percentageVisibility: response?.data?.chat?.percentage ?? 0,
      withinOpenHours: response?.data?.chat?.open ?? false,
    }
  } catch (err) {
    throw new Error(`Contact manager api error: ${err}`)
  }
}
